import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { ScheduleFormState, EndRecurrenceType } from 'modules/campaigns/editor/types';
import { RecurrenceScheduleType } from 'modules/campaigns/lib/types';
import { BoldText } from 'modules/campaigns/editor/styles';
import { getSkipOnDaysText } from 'modules/campaigns/lib/utils';
import {
  RECURRENCE_TYPE_LABEL_MAPPER,
  END_RECURRENCE_TYPE_LABEL_MAPPER,
} from '../ConfirmScheduleCampaignModal.constants';

export const ScheduleRecurrenceSummary = ({ values }: { values: ScheduleFormState }) => {
  const { endDate, endType, recurrence, skipOnDays, recurrenceFrequency } = values;

  const recurrenceText =
    recurrence === RecurrenceScheduleType.Custom
      ? RECURRENCE_TYPE_LABEL_MAPPER[recurrence]({
          recurrenceFrequency,
          pluralLetter: `${parseInt(recurrenceFrequency, 10) === 1 ? '' : 's'}`,
        })
      : RECURRENCE_TYPE_LABEL_MAPPER[recurrence];

  const end = moment(endDate).format('dddd, MMMM Do YYYY');

  const endTypeText =
    endType === EndRecurrenceType.OnDate
      ? END_RECURRENCE_TYPE_LABEL_MAPPER?.[endType]({
          endDate: end,
        })
      : END_RECURRENCE_TYPE_LABEL_MAPPER?.[endType as EndRecurrenceType];

  return (
    <>
      It will repeat <BoldText>{recurrenceText}</BoldText>
      {!isEmpty(skipOnDays) && (
        <>
          {', '}
          skipping <BoldText>{getSkipOnDaysText(skipOnDays, true)}</BoldText>
        </>
      )}{' '}
      and{' '}
      <BoldText>
        <>{endTypeText}</>
      </BoldText>
      .
    </>
  );
};
